import $foreign from "./foreign.cjs";
var _foreachUntil = $foreign._foreachUntil;
export { _foreachUntil };
